import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconCaretLeft, IconCaretRight } from '@redteclab/icons'

import { type ProductCarouselThumbnailNavButtonProps } from './ProductCarouselThumbnailNavButtonProps'

const ProductCarouselThumbnailNavButton: FC<
  ProductCarouselThumbnailNavButtonProps
> = ({ className, disabled, isRightButton, onClick }) => {
  return (
    <button
      className={clsx('cursor-pointer border-none bg-transparent', className)}
      disabled={disabled}
      onClick={onClick}
      type="button"
    >
      {isRightButton ? (
        <>
          <span className="sr-only">
            <FormattedMessage id="general.label.product.carousel.thumbnail.previous" />
          </span>
          <IconCaretRight
            className={clsx(
              'size-full fill-dark-primary-strong',
              disabled && 'fill-transparent',
              !disabled && 'group-hover:fill-dark-brand',
            )}
          />
        </>
      ) : (
        <>
          <span className="sr-only">
            <FormattedMessage id="general.label.product.carousel.thumbnail.next" />
          </span>
          <IconCaretLeft
            className={clsx(
              'size-full fill-dark-primary-strong',
              disabled && 'fill-transparent',
              !disabled && 'group-hover:fill-dark-brand',
            )}
          />
        </>
      )}
    </button>
  )
}

export { ProductCarouselThumbnailNavButton }
